module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_marmita.ccb89eee.png";